import { render, staticRenderFns } from "./CriteriaCardVars.vue?vue&type=template&id=0cf9a0e7"
import script from "./CriteriaCardVars.vue?vue&type=script&lang=js"
export * from "./CriteriaCardVars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports